/**
 * Vertical space block — empty {@code <div>} with a token-sized
 * height. Ported from ThemeMaker's
 * {@code blocks/layout/Spacer/Spacer.server.tsx}. Simplest block in
 * the catalogue.
 */
import { resolvePaddingStyle, type PaddingBox } from '../_shared/resolvePadding';
import { BlockRoot } from '../_shared/BlockRoot';

const sizeMap: Record<string, string> = {
  sm: 'var(--space-3, 12px)',
  md: 'var(--space-6, 24px)',
  lg: 'var(--space-12, 48px)',
  xl: 'var(--space-16, 64px)',
};

export interface SpacerProps {
  size?: keyof typeof sizeMap;
  paddingOuter?: PaddingBox;
  paddingInner?: PaddingBox;
}

export function Spacer({ size = 'md', paddingOuter, paddingInner }: SpacerProps) {
  const outerPad = resolvePaddingStyle(paddingOuter);
  const innerPad = resolvePaddingStyle(paddingInner);
  return (
    <BlockRoot as="div" style={{ height: sizeMap[size] ?? sizeMap['md'], ...outerPad }} aria-hidden>
      <div style={innerPad} />
    </BlockRoot>
  );
}
